import { isEmpty } from 'lodash'
import { ModifyTrade /* , TradeObject */ } from '@bdswiss/mt4-connector'
import {
  CloseAllTrades,
  resubscribeSymbols,
  showError,
  ResubscribeSymbols,
  SetType,
} from '../actions'
import { CancelPendingOrderAction } from '../actions/TradeActions'
import {
  CHANGE_SYMBOL,
  CLOSE_ALL_TRADES,
  CLOSE_TRADE,
  CONNECTION_REESTABLISHED,
  FULFILL_LOGIN,
  FULFILL_PRICES,
  FULFILL_TICK,
  MODIFY_TRADE,
  RESUBSCRIBED_SYMBOLS,
  SET_AMOUNT,
  INPUT_AMOUNT,
  SET_TAKEPROFIT,
  SET_STOPLOSS,
  OPEN_TRADE,
  CLEAR_STATE,
  SET_PRICE,
  CANCEL_PENDING_ORDER,
  SET_ACCOUNT_TYPE,
  INPUT_POSITION_PRICE,
  INPUT_POSITION_STOPLOSS,
  INPUT_POSITION_TAKEPROFIT,
  SET_TRADING_SYMBOL,
} from '../constants'
import { Epic, ActionsObservable } from 'redux-observable'
import { Mt4TraderService } from '../utils/mt4-trader-service'
import { RootState, TradingPaneValues } from '../types'
import { MiddlewareAPI, Action } from 'redux'
import { Observable } from 'rxjs/Observable'
import {
  MT4Connector,
  calculateLots,
  calcPl,
  calcSlInitial,
  calcTpInitial,
  calculateRequiredMargin,
  calculateInitialLots,
  calculateValue,
  calcVolume,
  findChainRate,
  getProfitCurrency,
  calcPendingPriceValue,
} from '@bdswiss/mt4-connector'
import {
  CloseTradeAction,
  // modifyTrade,
  ModifyTradeAction,
  OpenTradeAction,
  InputAmount,
} from '../actions/TradeActions'
import { I18n } from 'react-redux-i18n'
import {
  EnableTradeControls,
  enableTradeControls,
  refreshTradingValues,
  TradeValuesUpdate,
  updateTradingValues,
} from '../actions/commonActions'
import { SetModal, setModal } from '../actions/dialogActions'
import { reloginToMt4 } from '../actions/mt4Actions'

const mt4: MT4Connector = MT4Connector.Instance
const service: Mt4TraderService = new Mt4TraderService(mt4)

export const openTradeEpic: Epic<Action, RootState> = (action$, state: MiddlewareAPI<RootState>) =>
  (action$ as ActionsObservable<OpenTradeAction>).ofType(OPEN_TRADE).mergeMap(action => {
    const { cmd } = action
    const { symbol, signal } = state.getState().appState
    if (isEmpty(mt4.assets)) return Observable.empty()
    const asset = mt4.assets[symbol]
    if (!asset) return Observable.empty()
    const { amount, tradeType } = state.getState().tradingPane
    const {
      stopLoss: sl,
      takeProfit: tp,
      price,
      stopLossEnabled,
      takeProfitEnabled,
      pendingOrderEnabled,
    } = state.getState().tradingPane[tradeType]
    const signalId = signal ? signal.id : null
    try {
      return (
        service
          .openTrade(
            asset.symbol,
            cmd,
            calcVolume(amount, asset),
            pendingOrderEnabled ? price : 0,
            stopLossEnabled ? sl : 0,
            takeProfitEnabled ? tp : 0,
            signalId
          )
          .map(() => enableTradeControls())
          // .map(({ uuid, order }: TradeObject) =>
          //   stopLossEnabled || takeProfitEnabled
          //     ? pendingOrderEnabled
          //       ? modifyTrade(
          //           order,
          //           uuid,
          //           stopLossEnabled ? sl : 0,
          //           takeProfitEnabled ? tp : 0,
          //           cmd === 'buy' ? 'buy limit' : 'sell limit',
          //           price
          //         )
          //       : modifyTrade(order, uuid, stopLossEnabled ? sl : 0, takeProfitEnabled ? tp : 0, cmd)
          //     : enableTradeControls()
          // )
          .catch(e => handleServerTradeOperationError(e))
      )
    } catch (e) {
      return handleClientTradeOperationError(e)
    }
  })

export const closeAllTradesEpic: Epic<CloseAllTrades, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(CLOSE_ALL_TRADES).mergeMap((action: CloseAllTrades) => {
    service.closeAllTrades()
    return Observable.empty()
  })

export const closeTradeEpic: Epic<Action, RootState> = (action$, state: MiddlewareAPI<RootState>) =>
  (action$ as ActionsObservable<CloseTradeAction>)
    .ofType(CLOSE_TRADE)
    .mergeMap(({ order, uuid }) => {
      const item = mt4.positions.get(order) // state.getState().trades[order];
      try {
        if (item) {
          return service
            .closeTrade({ order, uuid, volume: item.volume })
            .catch(e => handleServerTradeOperationError(e))
        } else {
          return handleClientTradeOperationError(new Error(I18n.t('failedPositionClose')))
        }
      } catch (e) {
        return handleClientTradeOperationError(e)
      }
    })

export const cancelTradeEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  (action$ as ActionsObservable<CancelPendingOrderAction>)
    .ofType(CANCEL_PENDING_ORDER)
    .mergeMap(({ order, uuid }) => {
      const item = mt4.pendingOrders.get(order) // state.getState().pendingOrders[order];
      try {
        if (item) {
          return service
            .cancelPendingTrade({ order, uuid })
            .catch(e => handleServerTradeOperationError(e))
        } else {
          return handleClientTradeOperationError(new Error(I18n.t('failedPositionClose')))
        }
      } catch (e) {
        return handleClientTradeOperationError(e)
      }
    })

export const modifyTradeEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  (action$ as ActionsObservable<ModifyTradeAction>)
    .ofType(MODIFY_TRADE)
    .mergeMap(({ order, uuid, sl, tp, price, tradeType }) => {
      try {
        const payload: ModifyTrade = { order, uuid, sl, tp, price }
        // const obs: Observable<TradeObject> = service.modifyTrade(payload)
        //     .merge(Observable.of(enableTradeControls()));
        return service
          .modifyTrade(payload, tradeType!)
          .catch(e => handleServerTradeOperationError(e))
      } catch (e) {
        return handleClientTradeOperationError(e)
      }
    })

export const handleClientTradeOperationError = (e: any): Observable<Action> =>
  Observable.of<Action>(showError(e as Error), enableTradeControls())

export const handleServerTradeOperationError = (
  error: any
): Observable<SetModal | EnableTradeControls> => {
  if (error.uuid) {
    return Observable.of(enableTradeControls(error.uuid))
  } else {
    return Observable.of(
      setModal(I18n.t('communicationProblems'), I18n.t('reloadTrades'), reloginToMt4())
    )
  }
}

export const handleChangeSymbolEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  Observable.merge(
    Observable.zip(action$.ofType(FULFILL_PRICES), action$.ofType(FULFILL_LOGIN), () => true),
    action$.ofType(CHANGE_SYMBOL)
  ).map(() => resubscribeSymbols(new Set()))

export const handleReconnectEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(CONNECTION_REESTABLISHED).map(action => {
    return resubscribeSymbols(new Set())
  })

export const handleResubscribeSymbolEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  (action$ as ActionsObservable<ResubscribeSymbols | SetType>)
    .ofType(RESUBSCRIBED_SYMBOLS, SET_ACCOUNT_TYPE)
    .switchMap(() => {
      const { assetsOpened, appType } = state.getState().appState
      if (assetsOpened && appType === 'forex') {
        setTimeout(() => mt4.subscribeToSymbol('@ALL'), 0)
      } else {
        setTimeout(() => mt4.unsubscribeFromSymbol('@ALL'), 0)
      }
      return Observable.empty()
    })

export const updateAmountValuesEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  (action$ as ActionsObservable<InputAmount>).ofType(INPUT_AMOUNT).switchMap(action => {
    if (isEmpty(mt4.assets)) return Observable.empty()
    const prices = { ...mt4.assets }
    const { appState, tradingPane } = state.getState()
    const asset = prices[appState.symbol]
    if (!asset) return Observable.empty()
    const tradingAccount = { ...mt4.account }
    const { buy, sell, amountInitial, lotsInitial } = tradingPane
    const { leverage, currency } = tradingAccount!
    const { marginCurrency, lotStep } = asset
    const marginRate = findChainRate(marginCurrency, currency, prices).value
    const { amount } = action

    const lotFraction = lotStep.toString().split('.')[1]
    const lots = +calculateLots(asset, amount).toFixed(lotFraction ? lotFraction.length : 0)

    let newBuy: TradingPaneValues
    let newSell: TradingPaneValues
    {
      const tradeType = 'buy'
      const isPendingOrder = tradingPane.buy.pendingOrderEnabled
      const price = tradingPane.buy.price
      const buyAsset = isPendingOrder ? { ...asset, mask: price } : asset
      const value = calculateValue(buyAsset, amount, tradeType)
      const valueAccount = value * marginRate
      const requiredMargin = calculateRequiredMargin(value, leverage, buyAsset, tradeType)
      const requiredMarginAccount = requiredMargin * marginRate

      newBuy = {
        ...buy,
        value,
        valueAccount,
        requiredMargin,
        requiredMarginAccount,
      }
    }
    {
      const tradeType = 'sell'
      const isPendingOrder = tradingPane.sell.pendingOrderEnabled
      const price = tradingPane.sell.price
      const sellAsset = isPendingOrder ? { ...asset, mbid: price } : asset
      const value = calculateValue(sellAsset, amount, tradeType)
      const valueAccount = value * marginRate
      const requiredMargin = calculateRequiredMargin(value, leverage, sellAsset, tradeType)
      const requiredMarginAccount = requiredMargin * marginRate

      newSell = {
        ...sell,
        value,
        valueAccount,
        requiredMargin,
        requiredMarginAccount,
      }
    }
    return Observable.of(updateTradingValues(lotsInitial, lots, amountInitial, newBuy, newSell))
  })

export const updateTradingValuesEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$
    .ofType(
      FULFILL_TICK,
      SET_AMOUNT,
      SET_TAKEPROFIT,
      SET_STOPLOSS,
      SET_PRICE,
      INPUT_POSITION_PRICE,
      INPUT_POSITION_STOPLOSS,
      INPUT_POSITION_TAKEPROFIT
    )
    .mergeMap(action => {
      if (isEmpty(mt4.assets)) return Observable.empty()
      const prices = { ...mt4.assets }
      const { appState, tradingPane } = state.getState()
      const asset = prices[appState.symbol]
      if (!asset || asset.trade < 1) return Observable.empty()
      const tradingAccount = { ...mt4.account }
      const { leverage, currency } = tradingAccount!
      const { mbid, mask, marginCurrency, lotSize, lotStep } = asset
      const marginRate = findChainRate(marginCurrency, currency, prices).value
      const profitRate = findChainRate(getProfitCurrency(asset), currency, prices).value
      const lotsInitial = calculateInitialLots(tradingAccount!, asset, prices)
      const amountInitial = lotsInitial * lotSize
      const { amountInput } = tradingPane

      const lotFraction = lotStep.toString().split('.')[1]
      const lots = +calculateLots(asset, amountInput).toFixed(lotFraction ? lotFraction.length : 0)

      let buy: TradeValuesUpdate
      let sell: TradeValuesUpdate
      {
        const tradeType = 'buy'
        const isPendingOrder = tradingPane.buy.pendingOrderEnabled
        const price = tradingPane.buy.price
        const priceInitial = calcPendingPriceValue(tradeType, asset, asset.currentRate)
        const buyAsset = isPendingOrder ? { ...asset, mask: price } : asset
        const value = calculateValue(buyAsset, amountInput, tradeType)
        const valueAccount = value * marginRate
        const requiredMargin = calculateRequiredMargin(value, leverage, buyAsset, tradeType)
        const requiredMarginAccount = requiredMargin * marginRate

        const tp = calcTpInitial(
          tradeType,
          asset,
          isPendingOrder ? price : undefined,
          isPendingOrder
        )
        const sl = calcSlInitial(
          tradeType,
          asset,
          isPendingOrder ? price : undefined,
          isPendingOrder
        )
        const { takeProfit, stopLoss } = tradingPane[tradeType]
        const profit =
          calcPl(
            { ...buyAsset, mbid: takeProfit },
            tradeType,
            isPendingOrder ? price : mask,
            lots
          ) * profitRate
        const loss =
          calcPl({ ...buyAsset, mbid: stopLoss }, tradeType, isPendingOrder ? price : mask, lots) *
          profitRate
        // console.log(`takeProfit=${takeProfit} mask=${mask} profit=${profit} loss=${loss}`);

        buy = {
          value,
          valueAccount,
          requiredMargin,
          requiredMarginAccount,
          takeProfitInitial: tp,
          profit,
          profitPercent: (+profit.toFixed(2) * 100) / requiredMarginAccount,
          stopLossInitial: sl,
          loss,
          lossPercent: (+loss.toFixed(2) * 100) / requiredMarginAccount,
          priceInitial,
          price,
        }
      }
      {
        const tradeType = 'sell'
        const isPendingOrder = tradingPane.sell.pendingOrderEnabled
        const price = tradingPane.sell.price
        const priceInitial = calcPendingPriceValue(tradeType, asset, asset.currentRate)
        const sellAsset = isPendingOrder ? { ...asset, mbid: price } : asset
        const value = calculateValue(sellAsset, amountInput, tradeType)
        const valueAccount = value * marginRate
        const requiredMargin = calculateRequiredMargin(value, leverage, sellAsset, tradeType)
        const requiredMarginAccount = requiredMargin * marginRate
        const tp = calcTpInitial(
          tradeType,
          sellAsset,
          isPendingOrder ? price : undefined,
          isPendingOrder
        )
        const sl = calcSlInitial(
          tradeType,
          sellAsset,
          isPendingOrder ? price : undefined,
          isPendingOrder
        )
        const { takeProfit, stopLoss } = tradingPane[tradeType]
        const profit =
          calcPl(
            { ...sellAsset, mask: takeProfit },
            tradeType,
            isPendingOrder ? price : mbid,
            lots
          ) * profitRate
        const loss =
          calcPl({ ...sellAsset, mask: stopLoss }, tradeType, isPendingOrder ? price : mbid, lots) *
          profitRate

        sell = {
          value,
          valueAccount,
          requiredMargin,
          requiredMarginAccount,
          takeProfitInitial: tp,
          profit,
          profitPercent: (+profit.toFixed(2) * 100) / requiredMarginAccount,
          stopLossInitial: sl,
          loss,
          lossPercent: (+loss.toFixed(2) * 100) / requiredMarginAccount,
          priceInitial,
          price,
        }
      }
      return Observable.of(updateTradingValues(lotsInitial, lots, amountInitial, buy, sell))
    })

export const changeSymbolEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) => {
  return action$.ofType(CHANGE_SYMBOL, SET_TRADING_SYMBOL).switchMap(action => {
    return refreshAllTradingValues(state) as Observable<Action>
  })
}

export const refreshInitialTradingValuesEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) => {
  return Observable.zip(
    action$.ofType(FULFILL_LOGIN),
    action$.ofType(FULFILL_PRICES),
    () => true
  ).switchMap(() => refreshAllTradingValues(state) as Observable<Action>)
}

export const refreshInitialTradingValuesOnEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) => {
  return action$.ofType(CLEAR_STATE).switchMap(() => {
    return Observable.zip(
      action$.ofType(FULFILL_LOGIN),
      action$.ofType(FULFILL_PRICES),
      () => true
    ).switchMap(() => refreshAllTradingValues(state) as Observable<Action>)
  })
}

function refreshAllTradingValues(state: MiddlewareAPI<RootState>) {
  if (isEmpty(mt4.assets)) return Observable.empty()
  const prices = { ...mt4.assets }
  const { appState, tradingPane } = state.getState()
  const asset = prices[appState.symbol]
  if (!asset) return Observable.empty()
  const tradingAccount = { ...mt4.account }
  const { leverage, currency } = tradingAccount!
  const appType = appState.appType
  const { lotSize, lotStep, mbid, mask, marginCurrency } = asset
  const marginRate = findChainRate(marginCurrency, currency, prices).value
  const profitRate = findChainRate(getProfitCurrency(asset), currency, prices).value
  const lotsInitial = calculateInitialLots(tradingAccount!, asset, prices)
  const amount = appType === 'bond' ? 1 : lotsInitial * lotSize
  const lotFraction = lotStep.toString().split('.')[1]
  const lots = +calculateLots(asset, amount).toFixed(lotFraction ? lotFraction.length : 0)

  let buy: TradingPaneValues
  let sell: TradingPaneValues
  {
    const tradeType = 'buy'
    const isPendingOrder = tradingPane.buy.pendingOrderEnabled
    // const price = tradingPane.buy.price
    const priceInitial = calcPendingPriceValue(tradeType, asset, asset.mask)
    const buyAsset = isPendingOrder ? { ...asset, mask: priceInitial } : asset
    const value = calculateValue(buyAsset, amount, tradeType)
    const valueAccount = value * marginRate
    const requiredMargin = calculateRequiredMargin(value, leverage, buyAsset, tradeType)
    const requiredMarginAccount = requiredMargin * marginRate

    const tp = calcTpInitial(tradeType, asset, isPendingOrder ? priceInitial : undefined)
    const sl = calcSlInitial(tradeType, asset, isPendingOrder ? priceInitial : undefined)
    const { takeProfit, stopLoss } = tradingPane[tradeType]
    const profit =
      calcPl(
        { ...buyAsset, mbid: takeProfit },
        tradeType,
        isPendingOrder ? priceInitial : mask,
        lots
      ) * profitRate
    const loss =
      calcPl(
        { ...buyAsset, mbid: stopLoss },
        tradeType,
        isPendingOrder ? priceInitial : mask,
        lots
      ) * profitRate

    buy = {
      value,
      valueAccount,
      requiredMargin,
      requiredMarginAccount,
      takeProfitEnabled: false,
      takeProfitInitial: tp,
      takeProfit: tp,
      profit,
      profitPercent: (+profit.toFixed(2) * 100) / requiredMarginAccount,
      stopLossEnabled: false,
      stopLossInitial: sl,
      stopLoss: sl,
      loss,
      lossPercent: (+loss.toFixed(2) * 100) / requiredMarginAccount,
      pendingOrderEnabled: false,
      priceInitial,
      price: priceInitial,
    }
  }
  {
    const tradeType = 'sell'
    const isPendingOrder = tradingPane.sell.pendingOrderEnabled
    // const price = tradingPane.sell.price
    const priceInitial = calcPendingPriceValue(tradeType, asset, asset.mbid)
    const sellAsset = isPendingOrder ? { ...asset, mbid: priceInitial } : asset
    const value = calculateValue(sellAsset, amount, tradeType)
    const valueAccount = value * marginRate
    const requiredMargin = calculateRequiredMargin(value, leverage, sellAsset, tradeType)
    const requiredMarginAccount = requiredMargin * marginRate

    const tp = calcTpInitial(tradeType, sellAsset)
    const sl = calcSlInitial(tradeType, sellAsset)
    const { takeProfit, stopLoss } = tradingPane[tradeType]
    const profit =
      calcPl(
        { ...sellAsset, mask: takeProfit },
        tradeType,
        isPendingOrder ? priceInitial : mbid,
        lots
      ) * profitRate
    const loss =
      calcPl(
        { ...sellAsset, mask: stopLoss },
        tradeType,
        isPendingOrder ? priceInitial : mbid,
        lots
      ) * profitRate
    sell = {
      value,
      valueAccount,
      requiredMargin,
      requiredMarginAccount,
      takeProfitEnabled: false,
      takeProfitInitial: tp,
      takeProfit: tp,
      profit,
      profitPercent: (+profit.toFixed(2) * 100) / requiredMarginAccount,
      stopLossEnabled: false,
      stopLossInitial: sl,
      stopLoss: sl,
      loss,
      lossPercent: (+loss.toFixed(2) * 100) / requiredMarginAccount,
      pendingOrderEnabled: false,
      priceInitial,
      price: priceInitial,
    }
  }

  return Observable.of(
    refreshTradingValues(lotsInitial, lots, lots, amount, amount, amount, buy, sell)
  )
}
